import { createSelector } from "@reduxjs/toolkit";

export const getRemoteOrder = createSelector(
  (state) => state.remoteOrder.list,
  (list) => list
);
